export default {
    required(text = '') {
        return { required: true, message: `${text}不能为空` };
    },
    selectRequired(text = '') {
        return { required: true, message: `请选择${text}` };
    },
    number(minLimit, maxLimit, positive = false) {
        return {
            validator: (rule, value, callback) => {
                if (!value) {
                    return callback();
                }
                if (isNaN(value)) {
                    return callback(new Error('请填写数字'));
                }
                if (+value < 0) {
                    return callback(new Error('请填写大于等于0的数'));
                }
                if (positive && +value === 0) {
                    return callback(new Error('请填写大于0的数'));
                }
                if ((minLimit || maxLimit) && (+value < 10 ** minLimit - 1 - 1 || +value > 10 ** maxLimit)) {
                    return callback(new Error(`请填写${minLimit || 0}${maxLimit ? '到' : ''}${maxLimit || ''}位数字`));
                }
                callback();
            },
            trigger: 'blur'
        };
    },
    numberZone(minLimit = 0, maxLimit = 0, minLimitEq = true, maxLimitEq = true) {
        return {
            validator: (rule, value, callback) => {
                if (!value) {
                    return callback();
                }
                if (isNaN(value)) {
                    return callback(new Error('请填写数字'));
                }
                const tempVal = +value;
                const tips = ['请填写大于', minLimitEq ? '等于' : '', minLimit, '且小于', maxLimitEq ? '等于' : '', maxLimit, '的数字'].join('');
                if (
                    !(
                        ((minLimitEq && tempVal >= minLimit) || (!minLimitEq && tempVal > minLimit))
                        && ((maxLimitEq && tempVal <= maxLimit) || (!maxLimitEq && tempVal < maxLimit))
                    )
                ) {
                    return callback(new Error(tips));
                }
                callback();
            },
            trigger: 'blur'
        };
    },
    pureNumber(minLimit, maxLimit) {
        return {
            validator: (rule, value, callback) => {
                const reg = new RegExp(`^\\d{${minLimit},${maxLimit}}$`);
                if (!value) {
                    return callback();
                }
                if (!reg.test(value)) {
                    return callback(new Error(`请填写${minLimit}到${maxLimit}位数字`));
                }
                callback();
            },
            trigger: 'blur'
        };
    },
    moneyNumer(integerLimit, decimalLimit, zero = false, positive = false) {
        return {
            validator: (rule, value, callback) => {
                if (!value) {
                    return callback();
                }
                if (isNaN(value)) {
                    return callback(new Error('请填写数字'));
                }
                if (!zero && +value === 0) {
                    return callback(new Error('不能为0'));
                }
                if (!positive && +value <= 0) {
                    return callback(new Error('请填写大于0的数'));
                }
                const [integer, decimal = ''] = value.split('.');
                if (integerLimit !== 'infinity') {
                    if (integer.length > integerLimit || decimal.length > decimalLimit) {
                        if (integer.length > integerLimit && decimal.length > decimalLimit) {
                            return callback(new Error(`最多${integerLimit}位整数, ${decimalLimit}位小数`));
                        }
                        if (integer.length > integerLimit) {
                            return callback(new Error(`最多${integerLimit}位整数`));
                        }
                    }
                }
                if (decimal.length > decimalLimit) {
                    return callback(new Error(`最多${decimalLimit}位小数`));
                }
                callback();
            },
            trigger: 'blur'
        };
    },
    positiveInteger(zero = false, tips = '') {
        return {
            validator: (rule, value, callback) => {
                if (zero && +value === 0) {
                    return callback();
                }
                if (!/^[0-9]*[1-9][0-9]*$/.test(value)) {
                    return callback(new Error(tips || '请填写正整数'));
                }
                callback();
            },
            trigger: 'blur'
        };
    },
    letterAndNumber() {
        return {
            validator: (rule, value, callback) => {
                if (!/^[0-9a-zA-Z]*$/.test(value)) {
                    return callback(new Error('请填写数字和字母'));
                }
                callback();
            }
        };
    },
    len(min, max) {
        min = min || 0;
        max = max || 0;
        if (min && max) {
            if (min === max) {
                return { min: min, max: max, message: `请填写${min}个字符` };
            }
            return { min: min, max: max, message: `请填写${min}到${max}个字符` };
        }
        if (min) {
            return { min: min, message: `至少填写${min}个字符` };
        }
        if (max) {
            return { max: max, message: `最多填写${max}个字符` };
        }
    },
    email() {
        return { type: 'email', message: '请输入正确的邮箱地址' };
    },
    url() {
        return { type: 'url', message: '请输入正确的网址' };
    }
};
